<div class="payment-breakup" style="display:grid; grid-gap: 20px; grid-template-columns: 60% auto;">
  <nz-table [nzData]="dataSet" [nzShowPagination]="false">
    <thead>
      <tr>
        <th>#</th>
        <th>Transaction</th>
        <th>CR/DR</th>
        <th>Type</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>

      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td>Total</td>
        <td>
          <span class="f-s-1-7r col-red">
            Rs.
            <!-- <span [(countUp)]="totalPayoutAmt" [reanimateOnClick]="false">  </span>-->

          </span>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <div class="grid grid-gap-20">
    <nz-card *ngFor="let data of claimPaymentDOs">

      <!-- Heading -->
      <div class="grid grid-2x grid-gap-20 m-t-b-10">
        <div>
          <!-- TODO Organization Change -->
          <strong class="d-b">Nominee {{data?.clientDO?.personDO?.firstName}}
            {{data?.clientDO?.personDO?.lastName}}</strong>
          <small class="d-b col-green">
            <i nz-icon nzType="check" nzTheme="outline"></i> Bank details added
          </small>
        </div>
        <div>
          <small class="d-b">Sharing Percentage</small>
          <nz-input-group nzAddOnAfter="%">
            <input nz-input placeholder="Enter Percentage" [(ngModel)]="data.paymentSplitPrct" nzSize="large" />
          </nz-input-group>
        </div>
      </div>

      <!-- Form -->
      <div class="grid grid-2x grid-gap-20 m-t-b-10">
        <div>
          <small class="d-b">Benefit amount</small>
          <nz-input-group nzAddOnBefore="Rs.">
            <input nz-input placeholder="Enter Amount" nzSize="large" [ngModel]="commonUtilty.calculatePercentage(data.paymentSplitPrct, data.paymentAmt)"
              [disabled]="true" />
          </nz-input-group>
        </div>
        <div>
          <small class="d-b">Payout</small>
          <nz-select nzShowSearch  style="width: 100%">
            <nz-option [nzLabel]="'One Time'" [nzValue]="'ONETIME'"></nz-option>
            <nz-option [nzLabel]="'Periodic'" [nzValue]="'PERIODIC'"></nz-option>
          </nz-select>
        </div>
      </div>
      <div class="d-b m-t-b-10">
        <label [(ngModel)]="data.status" nz-checkbox>Authorize Payment</label>
      </div>
      <nz-form-item>
        <nz-form-control [nzSpan]="24">
          <textarea nz-input cols="30" rows="3" placeholder="Remarks ..."></textarea>
        </nz-form-control>
      </nz-form-item>
    </nz-card>
  </div>

</div>
